import React, { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { checkPermissions, checkSubscriptionPermission } from "../../helper";
import { fetchBusinessUnits } from "../../services/orgService";
import UpgradeMessageDialog from "../Subscription/UpgradeMessageDialog";
import { fetchEmployeeService } from "../../services/employeeService";

const FrequentActivities = () => {
  const navigate = useNavigate();
  const permissions = useSelector((state: any) => state.auth.userPermissions);
  const plansPermissions = useSelector(
    (state: any) => state.sub.subscriptionPermissions
  );
  const addonPermissions = useSelector(
    (state: any) => state.sub.addonPermissions
  );
  const [controller, setController] = useState({
    page: 0,
    limit: 10,
  });

  const [bunitsCount, setBunitsCount] = useState(0);
  const [employeeCount, setEmployeeCount] = useState(0);

  const [openBunitDialog, setBunitOpenDialog] = useState(false);
  const handleBunitClose = () => {
    setBunitOpenDialog(false);
  };

  const [openEmployeeDialog, setOpenEmployeeDialog] = useState(false);
  const handleEmployeeClose = () => {
    setOpenEmployeeDialog(false);
  };

  const [openTargetDialog, setOpenTargetDialog] = useState(false);
  const handleTargetClose = () => {
    setOpenTargetDialog(false);
  };

  const [openAssetDialog, setOpenAssetDialog] = useState(false);
  const handleAssetClose = () => {
    setOpenAssetDialog(false);
  };

  const handleAddNewUnitClick = () => {
    const reqObj: any = {
      controller: controller,
    };
    fetchBusinessUnits(reqObj).then((res) => {
      const total_count = res.data.total_count;
      setBunitsCount(total_count);
      if (
        total_count === 0 ||
        checkSubscriptionPermission(
          "FACILITY",
          plansPermissions,
          total_count,
          addonPermissions
        )
      ) {
        navigate("/organisation/facilityconfigurations");
      } else {
        setBunitOpenDialog(true);
      }
    });
  };

  const handleNewEmployeeClick = () => {
    const employeeObject = {
      controller,
    };
    fetchEmployeeService(employeeObject).then((res) => {
      if (res?.data) {
        const total_count = res.data.total_count;
        setEmployeeCount(total_count);
        if (
          total_count === 0 ||
          checkSubscriptionPermission(
            "USER",
            plansPermissions,
            total_count,
            addonPermissions
          )
        ) {
          navigate("/organisation/employee/add-employee");
        } else {
          setOpenEmployeeDialog(true);
        }
      }
    });
  };

  const handleNewTargetClick = () => {
    if (checkSubscriptionPermission("TARGETS", plansPermissions)) {
      navigate("/target");
    } else {
      setOpenTargetDialog(true);
    }
  };

  const handleNewAssetClick = () => {
    if (checkSubscriptionPermission("ASSETS", plansPermissions)) {
      navigate("/asset");
    } else {
      setOpenAssetDialog(true);
    }
  };

  return (
    <div className="flex flex-row justify-start items-start gap-6 p-4">
      {checkPermissions(["CREATE_FACILITY"], permissions) && (
        <div className="h-32 w-36 p-4 bg-white rounded-lg shadow-md flex-col justify-center items-center gap-3 inline-flex">
          <div
            className="h-14 relative cursor-pointer"
            onClick={() => {
              handleAddNewUnitClick();
            }}
          >
            <img src="assets/icons/Add_Business_Unit.svg" alt=" " />
          </div>
          <div className="text-neutral-800 text-sm font-medium font-['Proxima Nova']">
            Add Facility
          </div>
        </div>
      )}
      {checkPermissions(["CREATE_EMPLOYEE"], permissions) && (
        <div className="h-32 w-36 p-4 bg-white rounded-lg shadow-md flex-col justify-center items-center gap-3 inline-flex">
          <div
            className="h-14 relative cursor-pointer"
            onClick={() => {
              handleNewEmployeeClick();
            }}
          >
            <img src="assets/icons/Add_Employee.svg" alt=" " />
          </div>
          <div className="text-neutral-800 text-sm font-medium font-['Proxima Nova']">
            Add Employee
          </div>
        </div>
      )}
      {checkPermissions(["CREATE_TARGET"], permissions) && (
        <div className="h-32 w-36 p-4 bg-white rounded-lg shadow-md flex-col justify-center items-center gap-3 inline-flex">
          <div
            className="h-14 relative cursor-pointer"
            onClick={() => {
              handleNewTargetClick();
            }}
          >
            <img src="assets/icons/Add_Target.svg" alt=" " />
          </div>
          <div className="text-neutral-800 text-sm font-medium font-['Proxima Nova']">
            Add Target
          </div>
        </div>
      )}
      {checkPermissions(["CREATE_ASSET"], permissions) && (
        <div className="h-32 w-36 p-4 bg-white rounded-lg shadow-md flex-col justify-center items-center gap-3 inline-flex">
          <div
            className="h-14 relative cursor-pointer"
            onClick={() => {
              handleNewAssetClick();
            }}
          >
            <img src="assets/icons/Add_Asset.svg" alt=" " />
          </div>
          <div className="text-neutral-800 text-sm font-medium font-['Proxima Nova']">
            Add Asset
          </div>
        </div>
      )}
      {openBunitDialog && (
        <UpgradeMessageDialog
          open={openBunitDialog}
          onClose={handleBunitClose}
          limit={bunitsCount}
          limitType={bunitsCount === 1 ? "facility" : "facilities"}
        />
      )}
      {openEmployeeDialog && (
        <UpgradeMessageDialog
          open={openEmployeeDialog}
          onClose={handleEmployeeClose}
          limit={employeeCount}
          limitType={employeeCount === 1 ? "employee" : "employees"}
        />
      )}
      {openTargetDialog && (
        <UpgradeMessageDialog
          open={openTargetDialog}
          onClose={handleTargetClose}
        />
      )}
      {openAssetDialog && (
        <UpgradeMessageDialog
          open={openAssetDialog}
          onClose={handleAssetClose}
        />
      )}
    </div>
  );
};

export default FrequentActivities;
